import api from '../services/authService';

/**
 * Append one user-edit row to a document's field audit log.
 *
 * Paired with backend `TemplateMergeFieldAuditView` — see
 * `documents/views/template.py`. The initial Salesforce / template-default
 * snapshot is written server-side during the template merge; this endpoint
 * only ever carries `source='user'` rows.
 *
 * Returns the axios response; callers may ignore the resolve value.
 */
export const postFieldAuditEntry = async (documentId, { fieldKey, fieldName, value }) => {
  if (!documentId || !fieldKey) return null;
  try {
    return await api.post(`/documents/${documentId}/field-audit/`, {
      field_key: fieldKey,
      field_name: fieldName || '',
      value: value == null ? '' : String(value),
    });
  } catch (err) {
    // Audit writes must never surface to the user — log and move on so a
    // transient network hiccup doesn't derail an otherwise-successful edit.
    console.warn('[field-audit] POST failed:', err?.response?.status || err?.message);
    return null;
  }
};
